import { createFileRoute } from '@tanstack/react-router';
import { RoleBasedRewardsDashboard } from '@/pet/src/components/rewards/RoleBasedRewardsDashboard';

export const Route = createFileRoute('/dashboard/rewards')({
  component: PetsoRewards,
});

function PetsoRewards() {
  return <RoleBasedRewardsDashboard userType="owner" userId="user-1" />;
}
